module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CalendarModule', {
    attrs: {
      "isLoading": _vm.isLoading,
      "items": _vm.filteredData,
      "id": _vm.id
    },
    on: {
      "type": _vm.typeSelect
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a96a88a4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/views/calendar/Calendar.vue
// module id = 18709c4332169015d56d
// module chunks = 7